import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from './../../../../../Containers/Config/index';
import { GET_RULES, GET_RULES_SUCCESS, GET_RULES_ERROR } from './../../../actionType';
import apiCall from '../../../apiCall';
import { Constant } from '../../../../../Containers/Helpers/constant';

function* getRules({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/rules`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        pageSize: Constant?.TABLE_PAGE_SIZE,
        ...payload.urlParam,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_RULES_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_RULES_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_RULES_ERROR, payload: error });
  }
}

export function* watchGetRules() {
  yield takeEvery(GET_RULES, getRules);
}

function* getRulesSaga() {
  yield all([fork(watchGetRules)]);
}

export default getRulesSaga;
